import React, { PureComponent } from 'react';
import { ModalBase } from 'ui/lexus/containers';

const TITLE = 'Ошибка в совершении платежа';

class ModalError extends PureComponent {
    render() {
        const { text, onClose, orderNumber } = this.props;

        const errorTitle = orderNumber.length > 0 ? `${TITLE} № ${orderNumber}` : TITLE;

        return (
            <ModalBase
                title={errorTitle}
                content={
                    [`Текст ошибки: ${text}`, 'Пожалуйста, обратитесь в Клиентскую службу АО "Тойота Банк" по телефону 8 800 350 38 83']
                }
                onClose={onClose}
                error={true}
            />
        );
    }
}

export default ModalError;
